import { useBrowseLayoutDefinedFilteredComponentsQuery } from "../useBrowseLayoutDefinedFilteredComponentsQuery/useBrowseLayoutDefinedFilteredComponentsQuery";

export const useIsBrowseFpsLoadedAndHasNoResults = () => {
  const { isError, isFetching, data } =
    useBrowseLayoutDefinedFilteredComponentsQuery();

  const fpsComponents = data?.components;

  if (isFetching || fpsComponents === undefined) {
    return false;
  }

  if (isError) {
    return true;
  }

  const fpsGridComponent = fpsComponents.filter(
    (component) =>
      component.grid_component && component.is_required_for_interactivity
  );

  return fpsGridComponent.length === 0;
};
